export const CUSTOMIZER_REDUCER_NAME = 'customizer';
